import { Injectable } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { Event, Router, NavigationEnd } from '@angular/router';

const DEFAULT_PAGE_TITLE = 'Bill Chaser';

@Injectable()
export class TitleSetterService {
  pageRoute: string = null;
  routes: any;

  constructor(
    private titleService: Title,
    private router: Router,
  ) {}

  setTitle() {
    let title = DEFAULT_PAGE_TITLE;
    this.routes.forEach((route) => {
      if (route.path === this.router.url) {
        title = route.title;
      }
    });
    this.titleService.setTitle(title);
  }

  initialise(routes) {
    this.routes = routes;
    this.setTitle();
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        this.setTitle();
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/titlesetter.service.ts